<template>
  <AppDialog
    class="members-update-dialog"
    title="Update all members?"
    append-to-body
    show
    @close="close"
  >
    <div class="dialog-p">
      If you don’t want to update all members, you can exit this dialog and select specific members.
    </div>

    <template #footer>
      <div>
        <div class="d-flex justify-space-between align-items-center flex-column flex-sm-row mt-40 gap-20">
          <a
            class="nav-link"
            @click="skipToUpload"
          >
            Skip to upload
          </a>
          <div>
            <AppButton
              class="mr-15"
              type="default"
              @click="close"
            >
              Cancel
            </AppButton>
            <AppButton
              type="primary"
              :disabled="!!apiErrors?.length"
              @click="nextStep"
            >
              Update all members
            </AppButton>
          </div>
        </div>
      </div>
    </template>
  </AppDialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MembersUpdateAllDialog',
  computed: {
    ...mapGetters(['apiErrors']),
  },
  methods: {
    close() {
      this.$emit('close');
    },
    skipToUpload() {
      this.$emit('skipToUpload');
    },
    nextStep() {
      this.$emit('nextStep');
    },
  },
};
</script>
